export default {
  backend: process.env.BACKEND_URL || "http://localhost:7085/",
  portal: process.env.PORTAL_URL || "/portal",
  auth: process.env.AUTH_URL || "",
}